import { apiClient } from './apiClient';

export type UserNotification = {
  id: string;
  title: string;
  message: string;
  type: string;
  read: boolean;
  createdAtUtc: string;
  readAtUtc?: string | null;
  actionUrl?: string | null;
};

export type UserNotificationListResult = {
  items: UserNotification[];
  totalCount: number;
  unreadCount: number;
  page: number;
  pageSize: number;
};

export async function listUserNotifications(
  page = 1,
  pageSize = 20,
  unreadOnly?: boolean,
): Promise<UserNotificationListResult> {
  const params = new URLSearchParams({
    page: String(page),
    pageSize: String(pageSize),
  });
  if (unreadOnly) {
    params.set('unreadOnly', 'true');
  }

  const response = await apiClient.get<UserNotificationListResult>(
    `/v1/notifications?${params.toString()}`,
  );
  return response.data;
}

export async function getUnreadNotificationCount(): Promise<number> {
  const response = await apiClient.get<{ unreadCount: number }>('/v1/notifications/unread-count');
  return response.data.unreadCount;
}

export async function markNotificationAsRead(notificationId: string): Promise<void> {
  await apiClient.patch(`/v1/notifications/${notificationId}/read`);
}

export async function markAllNotificationsAsRead(): Promise<number> {
  const response = await apiClient.post<{ updatedCount: number }>('/v1/notifications/mark-all-read');
  return response.data.updatedCount;
}
